import type { TICKET_PURCHASE_HISTORY_STATUS as TicketPurchaseHistoryStatusType } from '@/enums/setting';

export const mappedTicketPurchaseHistoryStatusName: Record<TicketPurchaseHistoryStatusType, string> = {
	[TICKET_PURCHASE_HISTORY_STATUS.PAID]: 'Paid',
	[TICKET_PURCHASE_HISTORY_STATUS.REFUND]: 'Refunded',
};